export default function StatCard({ label, value, icon: Icon, mono, testid, accent }) {
    const isMonetary = accent === "gold";
    return (
        <div
            className="border border-[#E2E8F0] rounded-[6px] bg-white py-3 px-4 hover:shadow-md transition-shadow"
            style={{ boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}
            data-testid={testid}
        >
            <div className="flex items-center justify-between mb-1.5">
                <div className="text-[11px] uppercase tracking-[0.06em] text-[#64748B] font-medium leading-none">{label}</div>
                {Icon && <Icon className="w-4 h-4 flex-shrink-0" style={{ color: '#94A3B8' }} strokeWidth={1.75} />}
            </div>
            <div
                className={`text-2xl font-semibold tracking-tight leading-none ${mono ? "font-mono" : ""}`}
                style={{ color: isMonetary ? '#C9A227' : '#0B1F3A' }}
            >
                {value ?? "—"}
            </div>
        </div>
    );
}
